import {AgentHome} from './home/home';
import {BaseResponse} from './internal/baseresponse';

export class HomeResult extends BaseResponse {
  data: AgentHome;
}



// WEBPACK FOOTER //
// ./src/app/response/homeresult.ts